import {
    CompetenceTemplateApi,
    CompetenceTemplateQueryParams,
    CompetenceTemplateUpdateDTO,
    LearningCompetenceTypeEnum
} from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new CompetenceTemplateApi(getAuthConfiguration());

export const getCompetenceTemplates = (
    name?: string,
    type?: LearningCompetenceTypeEnum,
    page: number = 1,
    pageSize: number = 100
) => {
    const competenceTemplateQueryParams: CompetenceTemplateQueryParams = {
        name,
        type,
        page,
        pageSize,
    };

    return ApiFactory().apiCompetenceTemplateGetAllPost({ competenceTemplateQueryParams });
};

export const getCompetenceTemplateById = (id: string) => {
    return ApiFactory().apiCompetenceTemplateGetByIdIdGet({ id });
};

export const addCompetenceTemplate = (competenceTemplateUpdateDTO: CompetenceTemplateUpdateDTO) => {
    return ApiFactory().apiCompetenceTemplateAddPost({ competenceTemplateUpdateDTO });
};

export const updateCompetenceTemplate = (id: string, competenceTemplateUpdateDTO: CompetenceTemplateUpdateDTO) => {
    return ApiFactory().apiCompetenceTemplateUpdateIdPut({ id, competenceTemplateUpdateDTO });
};

export const deleteCompetenceTemplate = (id: string) => {
    return ApiFactory().apiCompetenceTemplateDeleteIdDelete({ id });
};
